/**
 *
 * UsageCountChip
 *
 */
import { memo } from 'react';
import { AsseticChip, ChipColor } from '@assetic/web-components';
import { useTheme, CSSObject } from '@mui/material';

interface StyleProps {
  overrideChipStyle?: CSSObject;
}

interface Props extends StyleProps {
  usage: number;
  limit: number;
  requireLimit?: boolean;
}

export const UsageCountChip = memo((props: Props) => {
  const { usage, limit, requireLimit = true, overrideChipStyle } = props;
  const theme = useTheme();
  let usageColor: ChipColor = 'secondary';
  if (usage > limit) usageColor = 'error_a';
  if (usage === limit) usageColor = 'warning';
  const limitLabel = requireLimit ? `/${limit}` : '';
  const label = `${usage}${limitLabel}`;

  return (
    <AsseticChip
      label={label}
      color={usageColor}
      overrideStyle={{
        ...theme.typography.subtitle1,
        fontWeight: 500,
        ...overrideChipStyle,
      }}
    />
  );
});
